// The mock fixtures' shapes: a board and threads as written by hand (poc.ts, platform.ts). They become the instances'
// logs (records.ts); what the board and chat show of them (blocked, open counts, statuses, columns, unread) is derived
// by the real client core the preview runs (instance.ts), so the derived fields here are placeholders.
import type { Project, Snapshot, Task, Thread } from "../types";

/** A fixture as written. */
export type RawBoard = {
	tasks: (Omit<Task, "blocked" | "pending" | "instance"> & { instance?: string | null })[];
	/** parent: the space it is in; stub: an ancestor the person sees only by name (the core derives depth, order) */
	projects: (Omit<Project, "open" | "instance" | "parent" | "depth" | "stub" | "type" | "statuses"> & { instance?: string | null; parent?: string | null; stub?: boolean; type?: Project["type"] })[];
	persons: Snapshot["persons"];
	repos: Snapshot["repos"];
};

export const board = (raw: RawBoard): Snapshot => ({
	...raw,
	tasks: raw.tasks.map((t) => ({ instance: null, ...t, blocked: false, pending: false })),
	projects: raw.projects.map((p) => ({ instance: null, parent: null, stub: false, type: "project" as const, ...p, open: 0, depth: 0, statuses: [] })),
	statuses: [],
	mine: [],
});

/** A fixture thread as written. */
export const thread = (t: Omit<Thread, "messages" | "general">): Thread => ({ ...t, messages: 0, general: !!t.about && t.about === t.spaceId });
